<template>
    <div v-if="skuInfo && has_show">
        <Wp_card_sku style="margin-left: 10px; margin-right: 10px" @click="buyGoods" class="skuCardStyle">

            <div id="img_div" slot="left">
                <Wp_image :url="skuInfo.pict_url"></Wp_image>
            </div>
            <div slot="right" style="margin-left: 10px">
                <div class="sku_title">
                    <h3>
                        <span>
                            <van-tag type="danger" style="font-size: 12px; padding: 0px 6px" v-if="skuInfo.user_type === 1">天猫</van-tag>
                            <van-tag type="danger" style="font-size: 12px; padding: 0px 6px" v-else>淘宝</van-tag>
                        </span>
                        {{skuInfo.title}}
                    </h3>
                </div>

<!--                <div v-if="$common.isClient_whole()" style="text-align: right; margin-bottom: -5px; color: #888888">-->
<!--                    <span style="margin-right: 15px">-->
<!--                    评论数 {{skuInfo.comments}}-->
<!--                </span>-->
<!--                    <span style="margin-right: 15px">-->
<!--                    好评率 {{skuInfo.goodCommentsShare}}%-->
<!--                </span>-->
<!--                </div>-->

                <!--                商品标签一行-->
                <div class="sku_tags" >
                    <div style="float:left;margin: 2px" v-if="couponData && couponData.discount">
                        <JdCouponBar :couponData="couponData"></JdCouponBar>
                    </div>

                    <div v-else style="float:left;margin: 2px 0px">
                        <!--                        用来占位-->
                        <JdCouponBar></JdCouponBar>
                    </div>

                    <div v-if="skuInfo.real_post_fee && skuInfo.real_post_fee === '0.00'" style="float:left;margin: 2px">
                        <van-tag color="red" plain>包邮</van-tag>
                    </div>

<!--                    <div style="position:absolute; right: 5px; margin-top: 2px">-->
<!--                        <van-tag color="#999999" plain>-->
<!--                            <span v-if="skuInfo.shop_title.length < 15">{{skuInfo.shop_title}}</span>-->
<!--                            <span v-else>{{skuInfo.shop_title.substring(0, 15) + '...'}}</span>-->
<!--                        </van-tag>-->
<!--                    </div>-->
                </div>

                <!--                佣金相关一行-->
                <div v-if="(!$common.gloabl_wx_openid || $common.gloabl_wx_mini_login_status === 'super' ) && !$common.isClient_whole()"
                     style="color:red" class="sku_price">
                    <Row>
                        <i-col span="12">
                            <!--                            佣金:{{skuInfo.commissionInfo.commission}}-->
                            预估佣金:￥{{commission}}
                        </i-col>
                        <i-col span="12">
                            <!--                            佣金比例:{{skuInfo.commissionInfo.commissionShare}}%-->
                            佣金比例:{{commissionShare}}%
                        </i-col>
                    </Row>
                </div>
                <!--                价格一行-->
                <div class="sku_price">
                    <div style="float:left;color:red">
                        <span v-if="couponData && couponData.discount">
                            <span>内购价:¥
                                <span class="result_price">{{(Number(skuInfo.zk_final_price) - Number(couponData.discount)).toFixed(2)}}</span>
                            </span>
                        </span>
                        <span v-else>
                            价格:¥<span class="result_price">{{skuInfo.zk_final_price}}</span>
                        </span>
                    </div>
                    <div style="float:left;margin-left: 10px; margin-top: 2px">
                        <div class="sku_old_price" v-if="couponData && couponData.discount">
                            <span style="font-size:10px;color:gray;text-decoration:line-through;">¥{{skuInfo.zk_final_price}}</span>
                        </div>
                    </div>
                </div>


                <div v-if="!$common.isClient_whole()" style="position: absolute; right: 5px; margin-top: 7px; color: orange;">
                    查看详情＞
                </div>

                <br/>
                <div v-if="$common.isClient_whole()" style="text-align: right; margin-top: 5px">
                    <van-button class="sku_card_bottom_btn"
                                type="danger"
                                size="small"
                                icon="shopping-cart-o"
                                v-on:click="buyGoods"
                    >立即购买
                    </van-button>
                </div>
            </div>

            <div slot="bottom" style="margin-top: 5px">
                <div style="text-align: right; margin-bottom: 10px">
<!--                    <span v-if="($common.gloabl_wx_openid && $config.project !== 'hm') || !$common.isClient_whole()" >-->
<!--                        <van-button class="sku_card_bottom_btn"-->
<!--                                    plain-->
<!--                                    type="danger"-->
<!--                                    size="small"-->
<!--                                    icon="shopping-cart-o"-->
<!--                                    v-on:click="buyGoods"-->
<!--                        >立即购买-->
<!--                        </van-button>-->
<!--                    </span>-->

                    <span v-if="(!$common.gloabl_wx_openid || $common.gloabl_wx_mini_login_status === 'super') && !$common.isClient_whole()">

<!--                        <span v-if="$common.global_robot_list && $common.global_robot_list.length > 0">-->
<!--                            <Wp_join_robot_button_model ref="Wp_join_robot_button_model"-->
<!--                                                        style="margin-right: 5px" :sku-info="skuInfo"-->
<!--                                                        :link-content="linkContent"-->
<!--                                                        :robot-list="$common.global_robot_list"-->
<!--                                                        :img-list="imageList"-->
<!--                                                        icon="add-o"-->
<!--                                                        :coupon-data="couponData"-->
<!--                                                        :refresh="refresh"-->
<!--                                                        @getPushStatus="getPushStatus"-->
<!--                                                        @getAllRobatSkuData="getAllRobatSkuData"-->
<!--                                                        @updataBadegSync="updataBadegSync"-->

<!--                            ></Wp_join_robot_button_model>-->
<!--                        </span>-->

<!--                        <van-button class="sku_card_bottom_btn"-->
<!--                                    plain-->
<!--                                    type="info"-->
<!--                                    size="small"-->
<!--                                    icon="add-o"-->
<!--                                    v-on:click="addInSelectList"-->
<!--                        >加入清单-->
<!--                        </van-button>-->

<!--                        <van-button class="sku_card_bottom_btn"-->
<!--                                    plain-->
<!--                                    type="primary"-->
<!--                                    size="small"-->
<!--                                    icon="photo-o"-->
<!--                                    @click="showDetailData"-->
<!--                        >详情数据-->
<!--                        </van-button>-->

                        <div v-if="skuInfo && skuInfo.shop_title" style="position:absolute; margin-top: 0px">
                            <van-tag color="#999999" plain size="medium" @click="showShopTitle(skuInfo.shop_title)">
                                <span v-if="skuInfo.shop_title.length < 15">{{skuInfo.shop_title}}</span>
                                <span v-else>{{skuInfo.shop_title.substring(0, 15) + '...'}}</span>
                            </van-tag>
<!--                            <van-button class="sku_card_bottom_btn"-->
<!--                                        plain-->

<!--                                        size="small"-->
<!--                                        icon="share"-->
<!--                                        color="#aaaaaa"-->
<!--                                        @click="showShopTitle(skuInfo.shop_title)"-->
<!--                            >-->
<!--                                <div slot="icon">-->
<!--                                    12-->
<!--                                </div>-->
<!--                                <span v-if="skuInfo.shop_title.length < 15">{{skuInfo.shop_title}}</span>-->
<!--                                <span v-else>{{skuInfo.shop_title.substring(0, 15) + '...'}}</span>-->
<!--                            </van-button>  -->
                        </div>

                        <van-button class="sku_card_bottom_btn"
                                    plain
                                    type="primary"
                                    size="small"
                                    icon="share"
                                    @click="makeCommand"
                        >生成淘口令
                        </van-button>

<!--                        <van-button class="sku_card_bottom_btn"-->
<!--                                    plain-->
<!--                                    type="primary"-->
<!--                                    size="small"-->
<!--                                    icon="share"-->
<!--                                    @click="showShareMenu"-->
<!--                        >商品推广-->
<!--                        </van-button>-->

<!--                        <Dropdown trigger="click" style="padding: 0px; margin: 0px">-->
<!--                            <van-button class="sku_card_bottom_btn"-->
<!--                                        plain-->
<!--                                        type="primary"-->
<!--                                        size="small"-->
<!--                                        icon="share"-->
<!--                                >商品推广-->
<!--                            </van-button>-->
<!--                            <DropdownMenu slot="list" style="">-->
<!--                                <DropdownItem style="padding: 0px">-->
<!--                                    <div style="text-align: center; font-size: 15px; padding: 10px" @click="makeLinks">-->
<!--                                        图文推广-->
<!--                                    </div>-->
<!--                                </DropdownItem>-->
<!--                                <Divider dashed-->
<!--                                         style="background-color: #999999;padding-left: 10px;padding-right: 10px; margin: 0px"></Divider>-->
<!--                                <DropdownItem style="padding: 0px">-->
<!--                                    <div style="text-align: center; font-size: 15px; padding: 10px" @click="showSharePop">-->
<!--                                        制作海报-->
<!--                                    </div>-->
<!--                                </DropdownItem>-->
<!--                            </DropdownMenu>-->
<!--                        </Dropdown>-->

<!--                        <van-action-sheet-->
<!--                                v-model="showShareBottomMenu"-->
<!--                                style="border-bottom: 1px solid #eeeeee"-->
<!--                        >-->
<!--                            <div style="margin-bottom: 5px; text-align: center; font-size: 17px; ">-->

<!--                                <div style="padding: 10px 0px;" @click="makeLinks">-->
<!--                                    <div>图文推广</div>-->
<!--                                    <div style="font-size: 10px; color: #aaaaaa;">使用图片+文字的方式进行商品推广</div>-->
<!--                                </div>-->
<!--                                <div style="height: 1px; background-color: #eeeeee"></div>-->
<!--                                <div style="padding: 10px 0px;" @click="showSharePop">-->
<!--                                    <div>制作海报</div>-->
<!--                                    <div style="font-size: 10px; color: #aaaaaa;">制作一张商品海报进行推广</div>-->
<!--                                </div>-->
<!--                                <div style="height: 6px; background-color: #eeeeee"></div>-->
<!--                                <div style="padding: 15px 0px;" @click="showShareBottomMenu = false">取消</div>-->
<!--                            </div>-->

<!--                        </van-action-sheet>-->



<!--                        <Wp_jd_skuinfo_poster ref="Wp_jd_skuinfo_poster"-->
<!--                                              :sku-info="skuInfo"-->
<!--                                              :coupon-data="couponData"-->
<!--                        ></Wp_jd_skuinfo_poster>-->

                    </span>
                </div>
            </div>
        </Wp_card_sku>
        <Divider dashed
                 style="background-color: #EE0A24;padding-left: 10px;padding-right: 10px; margin-top: 10px; margin-bottom: 10px"></Divider>
        <van-action-sheet
                title="推广详情"
                v-model="show_tb_command"
                @close="sheetClosed"
                style="padding-bottom: 30px; min-height: 90%"
        >

            <div style="margin-bottom: 50px">
                <Alert type="warning" style="margin-left: 10px;margin-right: 10px">转发步骤:1.长按保存图片,2.点击复制文案。</Alert>
                <div style="text-align: center" v-if="imageList.length > 0">
                    <!--                    <img :src="skuInfo.imageInfo.imageList[0].url" width="50%"/>-->
                    <van-swipe @change="onSwipeChange">
                        <van-swipe-item v-for="(image, index) in imageList" :key="index">
                            <Wp_image :url="image.img" :width="'50'"></Wp_image>
                        </van-swipe-item>
                        <div class="custom-indicator" slot="indicator">
                            {{ currentIndex + 1 }}/{{imageList.length}}
                        </div>
                    </van-swipe>
                </div>
                <div>
                    <van-field
                            v-model="linkContent"
                            type="textarea"
                            readonly
                            :autosize="{maxHeight: 300, minHeight: 100}"
                    ></van-field>
                </div>

            </div>
            <div style="text-align: center">
                <van-sticky :offset-top="50" style="position: fixed;bottom: 0px;text-align: center; width: 100%; padding: 10px;
                                background-color: #ffffff; box-shadow: 1px -1px 3px #999999">
                    <van-button v-if="tb_commmand"
                                type="info"

                                style="width: 90%; margin-bottom: 10px"
                                v-clipboard:copy="linkContent.replace(new RegExp('<br/>','gm'),'\n')"
                                v-clipboard:success="onCopySuccess"
                                v-clipboard:error="onError"
                    >复制文案
                    </van-button>

                </van-sticky>

            </div>


            <van-button id="stamp_button" ref="stamp_button" type="danger" plain
                        style="width: auto; height: auto; z-index:1;border-radius: 3px;
                        padding-left: 5px; padding-right:5px; padding-top: 5px; padding-bottom: 5px;
                        display: none;position: absolute;right:10%;bottom:42%; background-color: #ffffff77;
                        transform: rotate(25deg)"
            >
                <van-button type="danger" plain hairline
                            style="width:100%; height: 100%;border-radius: 3px;background-color: #ffffff77; "
                ><h3>复制成功</h3>
                </van-button>
            </van-button>
        </van-action-sheet>

        <van-popup
                v-model="showDetail"
                position="bottom"
                :style="{ width: '100%', height: '100%' }"
        >
            <Wp_tb_sku_detail_page v-if="skuInfoData && showDetail"
                                   type="popup"
                                   :datas="skuInfoData"
                                   @clickToCloseDetail="clickToCloseDetail"
                                   @getAllRobatSkuData="getAllRobatSkuDataFromDetail"
                                   @updataBadegSync="updataBadegSync"
            ></Wp_tb_sku_detail_page>
        </van-popup>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Row, Col, Tag, Icon, Button, Divider, Alert, Dropdown, DropdownMenu , DropdownItem} from 'iview';

    import Wp_card_sku from "../../custom/Wp_card_sku";
    import Wp_image from "../../custom/Wp_image";
    import Wp_jd_skuinfo_poster from "../../custom/Wp_jd_skuinfo_poster";
    import Wp_join_robot_button_model from "../../custom/Wp_join_robot_button_model";
    import Wp_join_robot_status_tag_model from "../../custom/Wp_join_robot_status_tag_model";
    import {Toast, Dialog} from "vant";
    import JdCouponBar from "../../custom/JdCouponBar";
    import Wp_tb_sku_detail_page from "../pages_childs/Wp_tb_sku_detail_page";

    Vue.component('Divider', Divider);
    Vue.component('Row', Row);
    Vue.component('i-col', Col);
    Vue.component('Tag', Tag);
    Vue.component('Icon', Icon);
    Vue.component('i-button', Button);
    Vue.component('Alert', Alert);
    Vue.component('Dropdown', Dropdown);
    Vue.component('DropdownMenu', DropdownMenu);
    Vue.component('DropdownItem', DropdownItem);


    export default {
        name: "TbSkuInfoCard",
        components: {
            Wp_tb_sku_detail_page,
            JdCouponBar,
            Wp_join_robot_status_tag_model,
            Wp_join_robot_button_model,
            Wp_jd_skuinfo_poster, Wp_image, Wp_card_sku, },
        props: {
            skuInfo: {type: Object, default: null},
            // couponData: {type: Object, default: null},
            width: {type: String, default: '90%'},
            id_index: {type: Number, default: 0}
        },
        data() {
            return {
                couponData: {},
                //实际金额
                actual_cost: 0,
                //佣金金额
                commission: 0,
                //佣金比例
                commissionShare: 0,

                newLink: '',
                linkContent: '',
                show_tb_command: false,

                imageList: [],
                //swipe当前的index
                currentIndex: 0,

                // img_url: "http://img14.360buyimg.com/ads/jfs/t1/100807/6/530/269231/5dafaaf4Ece749f19/aa19bf49d95a5135.jpg",
                img_url: "",

                has_show: false,
                share_img_url: "",
                show_share_pop: '',

                position_id: '',

                showChooseMakePoster: false,

                shareUseTo: "",

                showLoading: false,

                skuInfoData: null,
                showDetail: false,

                showShareBottomMenu: false,

                is_pushed: false,

                refresh: '',

                tb_commmand: '',

                relationId: '',//this.$store.state.taobao_pid,//'2423136353',//渠道的id（我绑定的2423933096）
            }
        },
        created() {
            this.relationId = this.$common_tb.getTaobaoPid();

            if (this.skuInfo) {
                this.findCoupon();

                this.initCommission();
            }
        },

        mounted() {
            this.has_show = this.isCanShow();
            this.share_img_url = this.skuInfo.pict_url;
        },
        // computed: {
        //     /**
        //      * 动态旋转
        //      * @return {string}
        //      */
        //     iconstyle() {
        //         let arr = new Array();
        //         arr.push('transform:');
        //         arr.push('rotate(' + 30 + 'deg) ');
        //         return arr.join("");
        //
        //     }
        // },
        methods: {

            showShopTitle(title){
                Dialog.alert({
                    title: '店铺',
                    message: title
                });
            },

            /**
             * 更新角标（来自Wp_join_robot_button_model或Wp_jd_sku_detail_page）
             */
            updataBadegSync(addOne){
                this.$emit("updataBadegSync", addOne);
            },

            /**
             * 获取全部数据（来自Wp_join_robot_button_model）
             */
            getAllRobatSkuData(data){
                this.$emit("getAllRobatSkuData", data);
            },
            /**
             * 获取全部数据（来自Wp_jd_sku_detail_page）
             */
            getAllRobatSkuDataFromDetail(data){
                this.$emit("getAllRobatSkuData", data);

                this.updateJoinRobotButtonStatus();
            },

            updateJoinRobotButtonStatus(){
                //更新加入助理按钮状态
                // this.$refs.Wp_join_robot_button_model.getPushStatus();//因可能为undefined，所以弃用此方式
                this.refresh = new Date().getTime().toString();

            },

            getPushStatus(push_status){
                this.is_pushed = push_status;
            },

            clickToCloseDetail(){
                this.showDetail = false;
            },

            /**
             * 立即购买
             */
            buyGoods() {
                //h5页面打开详情
                if(!this.$common.gloabl_wx_mini_user_info || !this.$common.gloabl_wx_mini_user_info.u_code || this.$common.isClient_whole()){
                    // this.$common.static_skuInfo = this.skuInfo;
                    // this.$router.push('sku_detail');

                    let _skuInfo = this.skuInfo;
                    //添加一个时间戳，已保证如果是同一个商品，在详情页面也能通过watch监听到
                    _skuInfo.time_tag = new Date().getTime();

                    this.skuInfoData = _skuInfo;

                    this.showDetail = true;

                }else{
                    //小程序中，使用小程序的page打开详情
                    this.$log("gloabl_wx_mini_login_status = " + this.$common.gloabl_wx_mini_login_status);
                    if (this.$common.gloabl_wx_mini_login_status) {
                        if (this.$common.gloabl_wx_mini_login_status === "none") {
                            //如果登录状态为none，则需要弹出一键登录界面
                            this.$log("---------需要登录---------")
                            // window.location.href = "#/mini_login";

                            this.navigateToLogin();
                        } else {
                            if (this.$common.gloabl_wx_mini_login_status === "normal") {
                                //如果是普通会员，并且有上级群主
                                if (this.$common.gloabl_wx_mini_user_info && this.$common.gloabl_wx_mini_user_info.f_id) {
                                    //使用上级群主的position_id进行购物
                                    this.position_id = this.$common.gloabl_wx_mini_user_info.f_id;
                                } else {
                                    //如果没有上级群主，则给他分配一个固定群主的position_id
                                    this.position_id = "1924367099";
                                }
                            }

                            if (this.$common.gloabl_wx_mini_login_status === "super") {
                                //如果是超级会员，并且登录了群主平台
                                if (this.$common.getPid()) {
                                    this.position_id = this.$common.getPid();
                                } else {
                                    if (this.$common.gloabl_wx_mini_user_info && this.$common.gloabl_wx_mini_user_info.channel_id) {
                                        //使用自己的群主id进行购物
                                        this.position_id = this.$common.gloabl_wx_mini_user_info.channel_id;
                                    }
                                }
                            }


                            //跳转小程序
                            let _skuId = this.skuInfo.skuId;

                            if (_skuId) {
                                this.navigateToDetail(_skuId);

                            }
                        }
                    }
                }


            },

            /**
             * 打开小程序的登录界面
             */
            navigateToLogin() {
                this.$common.navigateToMiniProgramPage("../wp_user_login/wp_user_login?event=login", null);
            },

            /**
             * 打开小程序中的详情界面
             */
            navigateToDetail(sku_str) {
                this.$common.navigateToMiniProgramPage("../wp_detail/wp_detail?", "skuId", sku_str);
            },

            /**
             * 加入选品清单
             */
            addInSelectList() {
                // this.$emit("addInSelectList", this.skuInfo.skuId);
                this.$emit("addInSelectList", this.skuInfo, this.skuInfo.skuId);
            },

            /**
             * 商品是否可以显示，如果有优惠券，则原价-优惠券的价格要大于0，否则不显示
             */
            isCanShow() {
                if (this.skuInfo) {
                    // this.$log(this.skuInfo.skuName)
                    // this.$log(this.skuInfo.shop_title)
                    // if(this.skuInfo.shop_title && this.skuInfo.shop_title.indexOf('[') === 1){
                    //     return false;
                    // }
                    // this.$log("this.commission = " +this.commission)
                    // if(Number(this.commission) < 0.1){
                    //     return false;
                    // }
                    if (this.skuInfo.coupon_amount) {
                        if (typeof (this.skuInfo.coupon_amount) == 'undefined') {
                            return true
                        }
                        if (Number(this.skuInfo.zk_final_price) - Number(this.couponData.discount) > 0) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            },


            /**
             * swipe滚动监听
             */
            onSwipeChange(index) {
                this.currentIndex = index;
            },
            /**
             * 查找优惠券
             */
            findCoupon() {
                if(this.skuInfo && this.skuInfo.coupon_amount){
                    this.couponData.discount = this.skuInfo.coupon_amount;
                    this.couponData.coupon_id = this.skuInfo.coupon_id;
                    this.couponData.coupon_share_url = this.skuInfo.coupon_share_url;
                    this.couponData.coupon_start_time = this.skuInfo.coupon_start_time;
                    this.couponData.coupon_end_time = this.skuInfo.coupon_end_time;
                    this.couponData.coupon_start_fee = this.skuInfo.coupon_start_fee;
                    this.couponData.coupon_info = this.skuInfo.coupon_info;
                    this.couponData.coupon_total_count = this.skuInfo.coupon_total_count;
                    this.couponData.coupon_remain_count = this.skuInfo.coupon_remain_count;
                }
            },

            initCommission(){
                if(this.skuInfo){
                    this.commissionShare = Number(this.skuInfo.commission_rate) / 100 * this.$common_tb.commissionRate_pir;

                    this.commission = 0;
                    if(this.skuInfo.coupon_amount){
                        this.commission = (Number(this.skuInfo.zk_final_price) - Number(this.skuInfo.coupon_amount)) * this.commissionShare / 100;
                    }else{
                        this.commission = Number(this.skuInfo.zk_final_price) * this.commissionShare / 100;
                    }
                    this.commissionShare = this.commissionShare.toFixed(2)
                    this.commission = this.commission.toFixed(2);
                }

                // //佣金比例，除以2，平分，0.9是订单返回数据中的finalRate最终比例
                // this.commissionShare = this.skuInfo.commissionInfo.commissionShare * 0.9 * this.$common.commissionRate_pir;
                // if (this.commissionShare.toString().indexOf(".") > 0) {
                //     this.commissionShare = (this.commissionShare).toFixed(2);
                // }
                //
                // if (this.couponData && this.couponData.discount) {
                //     //如果包含优惠券，佣金金额=(最低金额-优惠券金额) * 佣金比例 / 2 / 100，取小数点后两位，（除以2是平分实际佣金）
                //     this.commission = ((this.skuInfo.priceInfo.lowestPrice - this.couponData.discount) * (this.commissionShare / 100));
                // } else {
                //     // this.commission = (this.skuInfo.commissionInfo.commission / 2);
                //     this.commission = this.skuInfo.priceInfo.lowestPrice * (this.commissionShare / 100);
                // }
                // //取两位小数
                // this.commission = (this.commission).toFixed(2);
            },

            // onChange(value) {
            //     this.m_pid_list = value;
            //     if (this.m_pid_list) {
            //         this.linkList = [];
            //         for (let i in this.m_pid_list) {
            //             let _pid = this.m_pid_list[i];
            //             let _pidInfo = this.$common.splitPid(_pid);
            //             let _appInfo = this.$common.getAppKeyInfo(_pidInfo.media_id);
            //             let _data = {
            //                 id: _pid,
            //                 name: _pidInfo.channel_name,
            //                 pidInfo: _pidInfo,
            //                 appInfo: _appInfo,
            //                 newLink: '',
            //             };
            //             this.linkList.push(_data);
            //         }
            //     }
            //     // this.$emit('change',value);
            // },

            makeCommand(fn) {
                let loadingToast = Toast.loading({
                    message: '口令生成中...',
                    forbidClick: true,
                    duration: 0,
                });
                if(this.skuInfo && this.skuInfo.url){
                    let click_url = this.skuInfo.url + '&relationId=' + this.relationId;
                    //如果有优惠券，使用优惠券推广链接
                    if(this.skuInfo.coupon_share_url){
                        click_url = this.skuInfo.coupon_share_url + '&relationId=' + this.relationId;
                    }
                    this.$log("click_url = " + click_url)
                    let params = {
                        url: encodeURIComponent(encodeURIComponent('https:' + click_url)),
                        text: '您的优惠口令是'
                        // url: encodeURI('https:' + this.skuInfo.url)
                    };
                    this.$getTbCommand_tb(params, response=>{
                        this.$log(response)
                        if(response && response.code === 200){
                            this.tb_commmand = response.model;
                            this.getTbCommandContent(this.tb_commmand);
                            if(this.skuInfo.small_images){
                                for(let i = 0; i < this.skuInfo.small_images.string.length; i++){
                                    this.imageList.push({
                                        img: this.skuInfo.small_images.string[i]
                                    })
                                }
                            }else{
                                this.imageList.push({
                                    img: this.skuInfo.pict_url,
                                })
                            }
                            loadingToast.clear();
                            this.show_tb_command = true;
                        }
                    });
                }

            },

            showDetailData(){
                if(this.skuInfo && this.skuInfo.item_id){

                    let params = {
                        num_iids: this.skuInfo.item_id
                    };
                    this.$getSkuDetailData_tb(params, response=>{
                        this.$log(response)
                    });
                }

            },


            /**
             * 显示"复制成功"的图章
             */
            showStamp() {
                // let stampButton = document.getElementById('stamp_button');
                // stampButton.style.display = 'block';
                //展示"复制成功"图章
                this.$refs.stamp_button.style.display = 'block';
            },
            /**
             * sheet上拉模板关闭时回调
             */
            sheetClosed() {
                // let stampButton = document.getElementById('stamp_button');
                // stampButton.style.display = 'none';
                //删除"复制成功"图章
                this.$refs.stamp_button.style.display = 'none';
                //swipe所要加载的图片集合重置
                this.imageList = [];
                //swipe的indicator角标重置
                this.currentIndex = 0;
            },
            onCopySuccess() {
                this.showStamp();
                // setTimeout(() => {
                //     this.$notify({
                //         message: '\n复制成功\n ',
                //         duration: 2000,
                //         background: '#1989fa'
                //     });
                //
                // }, 500);

                Toast.success({
                    message: '复制成功'
                });

                // window.navigator.clipboard.readText().then(clipText=>{
                //     this.$log(clipText)
                // })
            },
            onError() {
                Toast.fail({
                    message: '复制失败'
                });
                // setTimeout(() => {
                //     this.$notify({
                //         message: '\n复制失败\n ',
                //         duration: 2000,
                //     });
                // }, 500);
            },
            getTbCommandContent(tbCommand) {
                let content = '';
                // content += '【' + this.skuInfo.brandName + '】' + this.skuInfo.skuName + '\n';
                let type = '淘寳';
                if(this.skuInfo.user_type === 1){
                    type = '天貓';
                }else{
                    type = '淘寳';
                }
                content += '【' + type + '】' + this.skuInfo.title + '\n';
                // content += '评论数: ' + this.skuInfo.comments + '  ';
                // content += '好评率: ' + this.skuInfo.goodCommentsShare + '%' + '\n';
                content += '--------------------------' + '\n';

                if (this.couponData && this.couponData.discount && typeof (this.couponData.discount) !== 'undefined'){

                    content +=  type + '价: ' + this.skuInfo.zk_final_price + '元(券' + this.couponData.discount + '元)' + '\n';

                    content += '内购价: ' + (Number(this.skuInfo.zk_final_price) - Number(this.couponData.discount)).toFixed(2) + '元' + '\n';
                }else{
                    content +=  type + '价: ' + this.skuInfo.zk_final_price + '元' + '\n';
                }
                content += 'kou令: ' + tbCommand + '\n';
                content += '复制kou令到淘宝中打开';
                // content += '--------------------------' + '\n';
                // let second_host_url = this.$store.state.username + '.wapg.cn';
                // content += '更多优惠: ' + second_host_url.toLowerCase();
                this.linkContent = content;
            },

            showShareMenu(){
                this.showShareBottomMenu = true;
            },

            showSharePop() {
                this.showShareBottomMenu = false;
                this.$refs.Wp_jd_skuinfo_poster.showSharePop();

                // this.showChooseMakePoster = true;
                //
                // if(!this.$common.gloabl_wx_mini_user_info || !this.$common.gloabl_wx_mini_user_info.u_code){
                //     this.showNormalSharePop();
                // }
            },
            showItems(){
                this.$refs.item.toggle(true);
            },

            // /**
            //  * 制作普通海报
            //  */
            // showNormalSharePop() {
            //     this.showChooseMakePoster = false;
            //     this.shareUseTo = "";
            //     this.showLoading = true;
            //     this.makeLinks(()=> {
            //         this.showLoading = false;
            //         let timestamp = "_" + Date.parse(new Date());
            //         this.show_share_pop = timestamp;
            //     })
            //     // this.$log(JSON.stringify(this.skuInfo))
            // },
            //
            // /**
            //  * 制作小程序海报
            //  * @param skuId
            //  */
            // showMiniAppSharePop(skuId){
            //     this.showChooseMakePoster = false;
            //     this.shareUseTo = "mini_app";
            //     this.showLoading = true;
            //     this.getQrcodeUrl(skuId, qr_img_url=>{
            //         this.newLink = qr_img_url;
            //         let timestamp = "_" + Date.parse(new Date());
            //         this.show_share_pop = timestamp;
            //     })
            // },
            //
            // getQrcodeUrl(skuId, fn){
            //     if(this.$common.gloabl_wx_mini_user_info){
            //         let u_code = this.$common.gloabl_wx_mini_user_info.u_code;
            //
            //         let params = {
            //             app_id: this.$common.wx_app_id,
            //             app_secret: this.$common.wx_app_secret,
            //             scene: u_code + ";" + skuId,
            //             width: 300
            //         };
            //         this.$getWxAppQrcode(params, response =>{
            //             this.$log(response)
            //             if(response && response.data){
            //                 this.showLoading = false;
            //                 let qr_img_url = response.data;
            //                 if (qr_img_url) {
            //                     if(fn){
            //                         fn(qr_img_url);
            //                     }
            //                 }
            //             }else{
            //                 this.showLoading = false;
            //                 this.$dialog.alert({
            //                     message: "邀请海报制作失败，请重试"
            //                 })
            //             }
            //         })
            //     }
            // },

            getImageIndex(index) {
                if (!index) {
                    index = 0;
                }
                this.share_img_url = this.skuInfo.small_images.string[index]

            },
        }
    }
</script>

<style scoped>
    .sku_info {
        font-size: 12px;
        text-align: left;
        margin: 5px;
    }

    .sku_title {
        /*height: 45px;*/
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }

    .sku_price {
        font-size: 14px;
    }

    .sku_old_price {
        font-size: 12px;
        text-align: center;
        padding-top: 0px;
    }

    .sku_month {
        font-size: 12px;
        text-align: left;
    }

    .sku_tags {
        display: inline-block;
        margin-top: 5px;
    }

    /*.van-popup--bottom {*/
    /*    border-radius: 12px 12px 0 0;*/
    /*}*/

    .custom-indicator {
        position: absolute;
        right: 5px;
        bottom: 5px;
        padding: 1px 7px;
        color: #fff;
        font-size: 12px;
        background: rgba(0, 0, 0, 0.3);
    }

    .sku_card_bottom_btn{
        margin-right: 5px;
        padding-left: 5px;
        padding-right: 5px
    }

    /deep/ .van-dropdown-menu .van-dropdown-menu__title  {
        font-size: 12px;
        color: #07C160;
    }

    /deep/ .van-dropdown-menu .van-dropdown-menu__item{
        padding: 0px;
        margin: 0px;
    }

    /*/deep/ .van-dropdown-menu .van-hairline--top-bottom::after{*/
    /*    border-width: 0px;*/
    /*}*/
    /deep/ .van-dropdown-menu .van-hairline{
        border: 4px solid #EE0A24;
    }

</style>
